(function ($, Drupal, drupalSettings, once) {
  'use strict';

  // Sticky Header - Desktop only.
  let isDesktop = false;
  let header = $('header#site-header');

  $(window).on('load resize', function () {
    if ($(window).width() >= 1025) {
      isDesktop = true;
    }
    else {
      isDesktop = false;
    }
    scrollFunction();
  });

  $(window).on('scroll', function () { scrollFunction(); });

  function scrollFunction() {
    if (isDesktop) {
      header.toggleClass('sticky', document.documentElement.scrollTop > 50);
    }
  }

})(jQuery, Drupal, drupalSettings, once); // eslint-disable-line no-undef
